import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d105af66-e3ca-4cf2-ba86-2b159e1d6f1a.jpg';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-61" data-mp="9lbhb4dgrhf6">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16 lg:py-24" data-id="element-62" data-mp="4m8lmajdinjv">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="128phrcgdev41">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-volt" data-id="element-64" data-mp="sde12olejdtn">
            For coaches, not athletes
          </p>
          <h1 className="mt-5 font-display text-5xl font-extrabold uppercase leading-[0.92] tracking-tightest text-white sm:text-6xl lg:text-7xl" data-id="element-65" data-mp="3d1scj2wkntvr">
            How to program, scale, and prepare{' '}
            <span className="text-volt" data-id="element-66" data-mp="3j898df6ywfql">elite HYROX athletes</span> without
            guesswork or overtraining
          </h1>
          <p className="mt-7 max-w-xl font-sans text-lg leading-relaxed text-muted" data-id="element-67" data-mp="3o73o289n1o6h">
            The proven roadmap for coaches who want to stop building random
            workouts and start producing competitive results.
          </p>

          <div className="mt-9" data-id="element-68" data-mp="30i18r72h87f5">
            <CtaButton data-id="element-69" data-mp="30hreh7aefe3n" />
          </div>
          <p className="mt-4 font-sans text-sm text-muted" data-id="element-70" data-mp="30gq5d8cy11ok">
            Immediate access • Secure payment • 7-day guarantee
          </p>
        </motion.div>

        <div className="relative" data-id="element-71" data-mp="2qkmtvbw7bqoy">
          <img src={HERO_IMAGE} alt="A HYROX athlete driving a loaded sled across the competition floor" className="aspect-[4/5] w-full rounded-sm object-cover grayscale-[35%]" data-id="element-72" data-mp="2qloeo830rrjv" />
          <div className="absolute -bottom-4 left-0 bg-volt px-5 py-3 sm:-left-4" data-id="element-73" data-mp="2hkggrr4f0sqb">
            <p className="font-display text-3xl font-extrabold uppercase leading-none text-ink" data-id="element-74" data-mp="2ll0i76w0uii9">
              8 stations
            </p>
            <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-ink/70" data-id="element-75" data-mp="s3co0h6r7vtq">
              1 method, zero guessing
            </p>
          </div>
        </div>
      </div>
    </header>;
}